import { render, staticRenderFns } from "./SecuritiesCompany.vue?vue&type=template&id=3949da16"
import script from "./SecuritiesCompany.vue?vue&type=script&lang=js"
export * from "./SecuritiesCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports